import React from 'react';
import FeedFooterComment from "../FeedFooterComment"
import FeedFooterLike from "../FeedFooterLike"
import FeedFooterShare from "../FeedFooterShare"
import FeedFooterCommentDetails from "../FeedFooterCommentDetails";
import iconPath from "./../../../helpers/iconHelper";

const FeedFooter = (props) => {
	let total_reaction  = props.total_reaction;
	let my_reaction 	= props.my_reaction;
	let total_comment   = props.total_comment;
	let total_share 	= props.total_share;
	let data_type 		= props.data_type;
	let feed_id 		= props.feed_id;
	let post_id 		= props.post_id;
	let position 		= props.position;
	let showCommentList = props.showCommentList;
	let toggleComment_feed_id = props.toggleComment_feed_id;
	let feed_reaction_details = props.feed_reaction_details;
	let new_post_id 		  = props.new_post_id;
   
  return (
	  <div>
    	<div className="post_footer">
			<div className="post-additional-info">
					
						<FeedFooterLike 
							total_reaction			= {total_reaction} 
							my_reaction				= {my_reaction} 
							data_type				= {data_type} 
							feed_id					= {(data_type == 'Promotion') ? post_id : feed_id} 
							position				= {position} 
							feed_reaction_details	= {feed_reaction_details}
						/>
						
					<div className="comments-shared">
						<FeedFooterComment 
							total_comment	= {total_comment} 
							data_type		= {data_type} 
							feed_id			= {feed_id} 
							post_id			= {post_id} 
							position		= {position}
						/>
						{data_type != 'Promotion' ? 
						<FeedFooterShare 
							total_share	= {total_share} 
							data_type	= {data_type} 
							feed_id		= {feed_id}
						/> : null
						}
					</div>
						
						
			</div>
		 </div>   
		  {(position != 'feed') ? 
			  <FeedFooterCommentDetails 
				  data_type				= {data_type} 
				  feed_id				= {(data_type == 'Promotion') ? post_id : feed_id} 
				  toggleComment_feed_id	= {toggleComment_feed_id} 
				  position				= {position}
			  />
          	: null
          } 
	  </div> 
  );
};

export default FeedFooter;